<template>
  <div class="c-p" @click="toProject">{{ params.data.project_title }}</div>
</template>

<script>
export default {
  methods: {
    toProject: function () {
      if (!this.params.data.project_id) return;
      let routeUrl = this.$router.resolve({
        path: "/home/admin/project_detail/" + this.params.data.project_id,
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
